import angular from "angular";

angular
    .module('app')
    .component('mobizonCardAdminMain', {
        template: require('./mobizon-card-admin-main.html'),
        controller: ['$http', controller],
        bindings: {}
    });

function controller($http) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.loading = true;
        $ctrl.getBalance();
    };

    $ctrl.getBalance = function () {
        $http
            .get('/admin/mobizon-messages/get-balance')
            .then(
                function (response) {
                    $ctrl.balance = Math.round(response.data.data.balance);
                    $ctrl.currency = response.data.data.currency;
                    $ctrl.loading = false;
                },
                function (error) {
                    alert(error.data.message || 'Undefined error');
                }
            );
    };
}